import React, {useEffect, useReducer} from 'react';
import {Button, ButtonGroup, Col, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip} from '@themesberg/react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPen, faPercent, faPowerOff, faTrashCan} from '@fortawesome/free-solid-svg-icons';
import {FormattedMessage} from 'react-intl';
import Utils from '../services/Utils';
import {useHistory} from 'react-router-dom';
import API from '../services/API';
import {DAYS_BORDER_COLOR} from '../services/constants';
import Error from '../services/Error';
import PageHeader from '../components/PageHeader';
import CrudTable from '../components/CrudTable';
import {usePlan} from '../services/PlanContext';
import SurchargeModePicker, {DEFAULT_SURCHARGE_MODE, OvernightDaysHint} from '../components/SurchargeModePicker';


export default (props) => {

  const formReducer = (state, event) => {
    if (event.value !== undefined) {
      return {
        ...state,
        [event.name]: event.value
      }
    } else {
      return event;
    }
  }

  const {intl} = props;
  const {plan, resourceLimit, openSubscription} = usePlan();
  const history = useHistory();
  const focus = ['focus'];
  const [showModal, setShowModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [editModalMode, setEditModalMode] = React.useState(false);
  const [currentSurchargeId, setCurrentSurchargeId] = React.useState(false);
  const [currentSurchargeName, setCurrentSurchargeName] = React.useState('');
  const [vehicles, setVehicles] = React.useState([]);
  const [surcharges, setSurcharges] = React.useState([]);
  // Limite calculée sur la liste locale (à jour après création/suppression), pas sur le compteur du plan.
  const locked = plan === 'FREE' && resourceLimit != null && surcharges.length >= resourceLimit;
  const [formData, setFormData] = useReducer(formReducer, {});
  const [currency, setCurrency] = React.useState({code: 'EUR', symbol: '€'});
  const [formatter, setFormatter] = React.useState(new Intl.NumberFormat(navigator.language, {style: 'currency', currency: 'EUR'}));

  const refreshSurcharges = () => {
    API.getSurcharges(history).then(response => {
      if (response && response.data.success === true) {
        setSurcharges(response.data.data.surcharges);
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  useEffect(() => {
    if (!Utils.isAccessToken(history)) {
      return;
    }
    refreshSurcharges();
    API.getCurrency(history).then(response => {
      if (response && response.data.success === true) {
        setFormatter(new Intl.NumberFormat(navigator.language, {
          style: 'currency',
          currency: response.data.data.code,
        }));
        setCurrency(response.data.data);
      }
    });
  }, []);

  const getVehicles = () => {
    API.getVehicles(history).then(response => {
      if (response && response.data.success === true) {
        const vehicles = response.data.data.vehicles.sort(function (a, b) {
          return a.position - b.position
        });
        setVehicles(vehicles);
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const handleChange = event => {
    setFormData({
      name: event.target.id,
      value: event.target.value
    });
  }

  const handleAddOrEdit = (e) => {
    e.preventDefault();

    if (vehicles.length === 0) {
      getVehicles();
    }

    if (editModalMode) {

      if (!formData.vehicleId) {
        formData.vehicleId = -1; // All vehicles
      }

      API.putSurcharges(history, formData, currentSurchargeId).then(response => {
        if (response && response.data.success === true) {
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SAVED_CHANGES'}));
          setShowModal(false);
          refreshSurcharges();
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    } else {

      if (!formData.monday) {
        formData.monday = false;
      }
      if (!formData.tuesday) {
        formData.tuesday = false;
      }
      if (!formData.wednesday) {
        formData.wednesday = false;
      }
      if (!formData.thursday) {
        formData.thursday = false;
      }
      if (!formData.friday) {
        formData.friday = false;
      }
      if (!formData.saturday) {
        formData.saturday = false;
      }
      if (!formData.sunday) {
        formData.sunday = false;
      }

      if (!formData.vehicleId) {
        formData.vehicleId = -1; // All vehicles
      }

      API.postSurcharges(history, formData).then(response => {
        if (response && response.data.success === true) {
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SURCHARGE_ADDED'}));
          setShowModal(false);
          refreshSurcharges();
        } else if (response && response.data && response.data.data === 'PLAN_LIMIT_REACHED') {
          setShowModal(false);
          openSubscription('RESOURCE_LIMIT');
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    }
  }

  const handleNewSurchargeButton = () => {
    if (vehicles.length === 0) {
      getVehicles();
    }

    setFormData({});
    setFormData({
      name: 'multiplier',
      value: 1
    });
    setFormData({
      name: 'calculationMode',
      value: DEFAULT_SURCHARGE_MODE
    });
    setEditModalMode(false);
    setShowModal(true);
  }

  const handleEditSurchargeButton = (props) => {
    let data = Object.assign({}, props);

    if (vehicles.length === 0) {
      getVehicles();
    }

    setFormData(data);
    setCurrentSurchargeId(data.id);
    setEditModalMode(true);
    setShowModal(true);
  }

  const handleEnableOrDisableButton = (props) => {
    if (props.active) {
      API.getDisableSurcharge(history, props.id).then(response => {
        if (response && response.data.success === true) {
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SURCHARGE_DISABLED'}));
          refreshSurcharges();
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    } else {
      API.getEnableSurcharge(history, props.id).then(response => {
        if (response && response.data.success === true) {
          // Gratuit : activer une 2ᵉ majoration bascule l'active au lieu de bloquer -> toast dédié.
          const switched = response.data.data === Error.resourceSwitched();
          Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: switched ? 'SURCHARGE_SWITCHED' : 'SURCHARGE_ENABLED'}));
          refreshSurcharges();
        } else if (response && response.data.success === false && response.data.data === Error.surchargeCannotBeEnabledWithoutVehicule()) {
          Utils.notifyWarning(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'YOU_MUST_ASSIGN_VEHICLE_BEFORE'}));
        } else {
          Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
        }
      });
    }
  }

  const handleDeleteSurchargeButton = (props) => {
    setCurrentSurchargeId(props.id);
    setCurrentSurchargeName(props.name);
    setShowDeleteModal(true);
  }

  const deleteSurcharge = () => {
    API.deleteSurcharges(history, currentSurchargeId).then(response => {
      if (response && response.data.success === true) {
        Utils.notifySuccess(intl.formatMessage({id: 'OK'}), intl.formatMessage({id: 'SURCHARGE_DELETED'}));
        setShowDeleteModal(false);
        refreshSurcharges()
      } else {
        Utils.notifyError(intl.formatMessage({id: 'ERROR'}), intl.formatMessage({id: 'ERROR_OCCURRED'}));
      }
    });
  }

  const handleClickDays = (e) => {
    switch (e.target.id) {
      case 'monday':
        setFormData({
          name: 'monday',
          value: formData.monday !== true
        });
        break;
      case 'tuesday':
        setFormData({
          name: 'tuesday',
          value: formData.tuesday !== true
        });
        break;
      case 'wednesday':
        setFormData({
          name: 'wednesday',
          value: formData.wednesday !== true
        });
        break;
      case 'thursday':
        setFormData({
          name: 'thursday',
          value: formData.thursday !== true
        });
        break;
      case 'friday':
        setFormData({
          name: 'friday',
          value: formData.friday !== true
        });
        break;
      case 'saturday':
        setFormData({
          name: 'saturday',
          value: formData.saturday !== true
        });
        break;
      case 'sunday':
        setFormData({
          name: 'sunday',
          value: formData.sunday !== true
        });
        break;
    }
  }

  const daysLabel = (s) => {
    const map = [['monday', 'MONDAY'], ['tuesday', 'TUESDAY'], ['wednesday', 'WEDNESDAY'],
      ['thursday', 'THURSDAY'], ['friday', 'FRIDAY'], ['saturday', 'SATURDAY'], ['sunday', 'SUNDAY']];
    let days = '';
    map.forEach(([field, id]) => {
      if (s[field]) {
        days += intl.formatMessage({id}).substring(0, 3) + '/';
      }
    });
    return days.length > 0 ? days.substring(0, days.length - 1) : '';
  };

  return (
    <div className="ccv2-crud">
      <PageHeader title="SURCHARGES" description="SURCHARGES_DESC"/>

      <CrudTable
        items={surcharges}
        intl={intl}
        columns={[
          {key: 'name', header: 'NAME', priority: 1},
          {key: 'startTime', header: 'START_TIME', headerMultiline: true, priority: 2},
          {key: 'endTime', header: 'END_TIME', headerMultiline: true, priority: 2},
          {key: 'weekdays', header: 'WEEKDAYS', priority: 2, render: (s) => daysLabel(s)},
          {key: 'calculationMode', header: 'SURCHARGE_MODE_COLUMN', priority: 3, hideBelow: 'lg',
            render: (s) => intl.formatMessage({id: `SURCHARGE_MODE_${s.calculationMode || DEFAULT_SURCHARGE_MODE}`})},
          {key: 'vehicle', header: 'VEHICLE', priority: 3, hideBelow: 'lg', render: (s) => (s.vehicleId === -1 ? intl.formatMessage({id: 'ALL_VEHICLES'}) : s.vehicleName)},
          {key: 'increaseAmount', header: 'INCREASE', numeric: true, priority: 2, render: (s) => formatter.format(s.increaseAmount)},
          {key: 'multiplier', header: 'MULTIPLIER', numeric: true, priority: 3, hideBelow: 'lg'},
          {key: 'active', header: 'ACTIVE_TAB', type: 'status', priority: 2},
        ]}
        actions={[
          {key: 'edit', icon: faPen, label: 'EDIT', onClick: handleEditSurchargeButton},
          {key: 'toggle', icon: faPowerOff, label: (s) => (s.active ? 'DISABLE' : 'ENABLE'), intent: 'warn', onClick: handleEnableOrDisableButton},
          {key: 'delete', icon: faTrashCan, label: 'DELETE', intent: 'danger', onClick: handleDeleteSurchargeButton},
        ]}
        toolbar={{onNew: handleNewSurchargeButton, newLabel: 'NEW_SURCHARGE', locked}}
        empty={{icon: faPercent, title: 'EMPTY_SURCHARGES_TITLE', description: 'EMPTY_SURCHARGES_DESC'}}
      />

      <Modal as={Modal.Dialog} centered show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6">{editModalMode ? <FormattedMessage id="EDIT_SURCHARGE"/> : <FormattedMessage id="NEW_SURCHARGE"/>}</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => setShowModal(false)}/>
        </Modal.Header>
        <Modal.Body>
          <Form id="add-surcharge-form" onSubmit={handleAddOrEdit}>
            <Row>
              <Form.Group>
                <Form.Label><FormattedMessage id="NAME"/></Form.Label>
                <Form.Control required type="text" id="name"
                              onChange={handleChange} value={formData.name}/>
              </Form.Group>
            </Row>
            <br/>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="START_TIME" values={{newLine: ' '}}/></Form.Label>
                  <Form.Control required type="time" id="startTime"
                                onChange={handleChange} value={formData.startTime}/>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="END_TIME" values={{newLine: ' '}}/></Form.Label>
                  <Form.Control required type="time" id="endTime"
                                onChange={handleChange} value={formData.endTime}/>
                </Form.Group>
              </Col>
            </Row>
            <br/>
            <Row>
              <Form.Label><FormattedMessage id="APPLICABLE_DAYS"/></Form.Label>
              <ButtonGroup>
                <Button id="monday" onClick={handleClickDays} variant={formData.monday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="MONDAY"/></Button>
                <Button id="tuesday" onClick={handleClickDays} variant={formData.tuesday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="TUESDAY"/></Button>
                <Button id="wednesday" onClick={handleClickDays} variant={formData.wednesday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="WEDNESDAY"/></Button>
                <Button id="thursday" onClick={handleClickDays} variant={formData.thursday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="THURSDAY"/></Button>
                <Button id="friday" onClick={handleClickDays} variant={formData.friday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="FRIDAY"/></Button>
                <Button id="saturday" onClick={handleClickDays} variant={formData.saturday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="SATURDAY"/></Button>
                <Button id="sunday" onClick={handleClickDays} variant={formData.sunday ? 'secondary' : 'outline-primary'} style={{borderColor: DAYS_BORDER_COLOR}}
                        size="sm"><FormattedMessage id="SUNDAY"/></Button>
              </ButtonGroup>
              <OvernightDaysHint mode={formData.calculationMode} startTime={formData.startTime} endTime={formData.endTime}/>
            </Row>
            <br/>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="INCREASE"/></Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={Utils.getCurrencyIcon(currency.code)}/>
                    </InputGroup.Text>
                    <Form.Control required type="number" id="increaseAmount" step="any" min="0" max="99999999.99"
                                  onChange={handleChange} value={formData.increaseAmount}/>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label><FormattedMessage id="MULTIPLIER"/></Form.Label>
                  <OverlayTrigger trigger={focus}
                                  overlay={
                                    <Tooltip><FormattedMessage id="TOOLTIP_SURCHARGE_MULTIPLIER"/></Tooltip>
                                  }>
                    <Form.Control required type="number" id="multiplier" step="any" min="0" max="99999999.99"
                                  onChange={handleChange} value={formData.multiplier}/>
                  </OverlayTrigger>
                </Form.Group>
              </Col>
            </Row>
            <br/>
            <Row>
              <Form.Group>
                <Form.Label><FormattedMessage id="SURCHARGE_MODE"/></Form.Label>
                <SurchargeModePicker value={formData.calculationMode}
                                     onChange={(mode) => setFormData({name: 'calculationMode', value: mode})}
                                     startTime={formData.startTime}
                                     multiplier={formData.multiplier}
                                     increaseAmount={formData.increaseAmount}
                                     formatter={formatter}/>
              </Form.Group>
            </Row>
            <br/>
            <Row>
              <Form.Group>
                <Form.Label><FormattedMessage id="VEHICLE"/></Form.Label>
                <Form.Select id="vehicleId" onChange={handleChange} value={formData.vehicleId}>
                  <option key={`vehicle-all`} value={-1}>{intl.formatMessage({id: 'ALL_VEHICLES'})}</option>
                  {vehicles.map(v => <option key={`vehicle-${v.id}`} value={v.id}>{v.name}</option>)}
                </Form.Select>
              </Form.Group>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit" form="add-surcharge-form">
            {editModalMode ? <FormattedMessage id="RECORD"/> : <FormattedMessage id="ADD"/>}
          </Button>
          <Button variant="link" className="text-gray ms-auto" onClick={() => setShowModal(false)}>
            <FormattedMessage id="CLOSE"/>
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal as={Modal.Dialog} centered show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header>
          <Modal.Title className="h6"><FormattedMessage id="DELETE_SURCHARGE" values={{name: currentSurchargeName}}/></Modal.Title>
          <Button variant="close" aria-label="Close" onClick={() => setShowDeleteModal(false)}/>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="danger" onClick={deleteSurcharge}>
            <FormattedMessage id="DELETE"/>
          </Button>
          <Button variant="link" className="text-gray ms-auto" onClick={() => setShowDeleteModal(false)}>
            <FormattedMessage id="CLOSE"/>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
    ;
};
